module.exports = [
  {
    key: 'FULL_BODY',
    label: {
      en: 'Full Body',
      es: 'Full Body',
    },
  },
  {
    key: 'HEAD',
    label: {
      en: 'Head',
      es: 'Head',
    },
  },
  {
    key: 'FACE',
    label: {
      en: 'Face',
      es: 'Face',
    },
  },
  {
    key: 'NOSE',
    label: {
      en: 'Nose',
      es: 'Nose',
    },
  },
  {
    key: 'EARS',
    label: {
      en: 'Ears',
      es: 'Ears',
    },
  },
  {
    key: 'MOUTH',
    label: {
      en: 'Mouth',
      es: 'Mouth',
    },
  },
  {
    key: 'EYES',
    label: {
      en: 'Eyes',
      es: 'Eyes',
    },
  },
  {
    key: 'NECK',
    label: {
      en: 'Neck',
      es: 'Neck',
    },
  },
  {
    key: 'CHEST',
    label: {
      en: 'Chest',
      es: 'Chest',
    },
  },
  {
    key: 'RIGHT_ARM_UPPER',
    label: {
      en: 'Upper Right Arm',
      es: 'Upper Right Arm',
    },
  },
  {
    key: 'RIGHT_ARM_LOWER',
    label: {
      en: 'Lower Right Arm',
      es: 'Lower Right Arm',
    },
  },
  {
    key: 'RIGHT_HAND',
    label: {
      en: 'Right Hand',
      es: 'Right Hand',
    },
  },
  {
    key: 'LEFT_ARM_UPPER',
    label: {
      en: 'Upper Left Arm',
      es: 'Upper Left Arm',
    },
  },
  {
    key: 'LEFT_ARM_LOWER',
    label: {
      en: 'Lower Left Arm',
      es: 'Lower Left Arm',
    },
  },
  {
    key: 'LEFT_HAND',
    label: {
      en: 'Left Hand',
      es: 'Left Hand',
    },
  },
  {
    key: 'ABDOMEN',
    label: {
      en: 'Abdomen',
      es: 'Abdomen',
    },
  },
  {
    key: 'BACK_UPPER',
    label: {
      en: 'Upper Back',
      es: 'Upper Back',
    },
  },
  {
    key: 'BACK_LOWER',
    label: {
      en: 'Lower Back',
      es: 'Lower Back',
    },
  },
  {
    key: 'GENITALIA',
    label: {
      en: 'Pelvis/Genitalia',
      es: 'Genitalia',
    },
  },
  {
    key: 'RIGHT_LEG_UPPER',
    label: {
      en: 'Upper Right Leg',
      es: 'Upper Right Leg',
    },
  },
  {
    key: 'RIGHT_LEG_LOWER',
    label: {
      en: 'Lower Right Leg',
      es: 'Lower Right Leg',
    },
  },
  {
    key: 'RIGHT_FOOT',
    label: {
      en: 'Right Foot',
      es: 'Right Foot',
    },
  },
  {
    key: 'LEFT_LEG_UPPER',
    label: {
      en: 'Upper Left Leg',
      es: 'Upper Left Leg',
    },
  },
  {
    key: 'LEFT_LEG_LOWER',
    label: {
      en: 'Lower Left Leg',
      es: 'Lower Left Leg',
    },
  },
  {
    key: 'LEFT_FOOT',
    label: {
      en: 'Left Foot',
      es: 'Left Foot',
    },
  },
  {
    key: 'BUTTOCKS',
    label: {
      en: 'Buttocks',
      es: 'Las Nalgas',
    },
  },
];
